const Color = {
  textColorBlack: "#232933",
  textColorBlackOne: "#616161",
  textColorBlackTow: "#9e9e9e",
  textColorBlackTree: "#858585",
  textColorBlackFor: "#414141",
  textColorBlackFive: "#cccdcf",
  textColorBlackSix: "#222",
  textColorBlackSeven: "#e1e1e1",
  textColorBlackEight: "#81858b",
  textColorBlackNine: "#b8babd;",
  colorPurpleLight: '#990BCD',
  colorPurple: '#8A0AB9',
  colorApp: '#1ab394',
  colorBlue: '#2288dc',
  colorWarning: '#e46d2b',
  colorRed: '#d54343',
  colorGreen: '#3aa488',
  colorPurpleBold: '#4A0264',
  colorWhite: '#fff',
  transparent: 'transparent',
  colorIndicator: '#444',
  colorBlueCard: '#003f8c',
  colorDefaultCard: '#393939',
  colorOrange: '#f76c33',
  iconColorB: '#888',
  navigationColor: 'rgb(30,144,255)',
  colorDarkOne: "#383838",
  colorDarkTow: "#555",
  colorAppOrange: "#f48f01",

  /* -------- button  -------- */

  //warning
  warningButton: "#e46d2b",
  warningBorder: "#e46d2b",
  //primary
  primaryButton: "#14a9d9 ",
  primaryBorder: "#14a9d9 ",
  //success
  successButton: "#3aa488",
  successBorder: "#3aa488",
  //danger
  dangerButton: "#d54343",
  dangerBorder: "#d54343",

  /* -------- end button  -------- */
};

export default Color;
